<template>
  <div>
    <el-dialog
      width="60%"
      title="吴忠仪表销售总公司出差申请单"
      :visible.sync="addCcsqdView"
      :before-close="colseCcsqd">
      <el-row style="text-align: center;margin-bottom: 20px">
        <span style="font-size: 20px">吴忠仪表销售总公司出差申请单</span>
      </el-row>
      <el-row style="text-align: left;margin-left: 20px">
        <el-col :span="7">申请部门：{{ addCcsqdData.deptName }}</el-col>
        <el-col :span="7">日期：{{ addCcsqdData.applyDate }}</el-col>
        <el-col :span="7">单据号：{{ addCcsqdData.billNumber }}</el-col>
        <el-col :span="3">单位： 元</el-col>
      </el-row>
      <el-row>
        <div style="display:inline-flex;width: 95%">
          <table ref="myTable" class="tableStyle" border>
            <tr>
              <td class="td1">申请人</td>
              <td class="td2">{{ addCcsqdData.applyPerson }}
                <el-input v-model="addCcsqdData.jkrId" style="width: 50%;display: none"></el-input>
              </td>
              <td class="td3"></td>
              <td class="td4"></td>
            </tr>
            <tr>
              <td class="td1">出差事由</td>
              <td class="td2">{{ addCcsqdData.reason }}</td>
              <!--                <el-radio-group v-model="addCcsqdData.reason" :disabled="view === 'see'" style="margin-left: 10px">-->
              <!--                  <el-radio :label="1">计划内项目</el-radio>-->
              <!--                  <el-radio :label="2">计划外项目</el-radio>-->
              <!--                  <el-radio :label="0">回款</el-radio>-->
              <!--                  <el-radio :label="5">会议</el-radio>-->
              <!--                  <el-radio :label="6">服务</el-radio>-->
              <!--                  <el-radio :label="7">验货</el-radio>-->
              <!--                  <el-radio :label="8">休假</el-radio>-->
              <!--                </el-radio-group>-->
              <td class="td3"></td>
              <td class="td4"></td>
            </tr>
            <tr v-if="addCcsqdData.ccsy === '1' || addCcsqdData.ccsy === '2' || addCcsqdData.ccsy === '0'">
              <td class="td1">出差项目</td>
              <td class="td2">{{ addCcsqdData.project }}</td>
              <td class="td3"></td>
              <td class="td4"></td>
            </tr>
            <tr v-else>
              <td class="td1">出差描述</td>
              <td class="td2">{{ addCcsqdData.ccms }}</td>
              <td class="td3"></td>
              <td class="td4"></td>
            </tr>
            <tr>
              <td class="td1">出差地点</td>
              <td class="td2">{{ addCcsqdData.locale }}</td>
              <td class="td3">销售公司经理</td>
              <td class="td4" style="text-align: center">{{ addCcsqdData.shr }}</td>
            </tr>
            <tr>
              <td class="td1">预计出差时间</td>
              <td class="td2">
                <div style="display: inline-flex">
                  <span class="yjsjStyle">日期</span>{{ rqFormatter(addCcsqdData.starttime) }}
                  <span class="yjsjStyle">至</span>{{ rqFormatter(addCcsqdData.endtime) }}
                  <span class="yjsjStyle">总计</span>{{ addCcsqdData.totalDays }}
                  <span class="yjsjStyle">天,其中路途</span>{{ addCcsqdData.roadDays }}
                  <span class="yjsjStyle">天</span>
                </div>
              </td>
              <td class="td3">经办人</td>
              <td class="td4" style="text-align: center">{{ addCcsqdData.operator }}</td>
            </tr>
          </table>
        </div>
        <div style="width: 20px;display: inline-flex;margin-left: 5px">
          <span>第<br>一<br>联<br>财务记<br>账<br>联</span>
        </div>
      </el-row>

      <el-row style="width: 95%">
        <el-divider content-position="left" style="width: 90%">审核情况</el-divider>
        <el-table
          class="tableClass"
          :data="shData"
          size="small"
          border
          :header-cell-style=" {background:'#F8FCFF',color:'#606266'}">
          <el-table-column label="序号" align="center" type="index" width="50" />
          <el-table-column label="日期" header-align="center" align="left" prop="shsj" />
          <el-table-column label="审核人" header-align="center" align="left" prop="shr" width="100px" />
          <el-table-column label="审核金额" header-align="center" align="right" prop="shje" />
          <el-table-column label="审核结果" header-align="center" align="left" prop="shbz">
            <template slot-scope="scope">
              <span>{{ scope.row.shbz === '1' ? '审核通过' : '审核不通过' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核意见" header-align="center" align="left" prop="shyj" />
        </el-table>
      </el-row>

      <el-row style="margin-top: 20px;text-align: center">
        <span class="dialog-footer">
          <el-button size="small" @click="closeAddCcsqdView()">关 闭</el-button>
        </span>
      </el-row>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'addCcsqd',
  props: {
    noSave: Boolean,
    addCcsqdData: {
      type: Object,
      default: () => {}
    },
    addCcsqdView: Boolean,
    colseCcsqd: {
      type: Function,
      default: () => {}
    },
    getList: {
      type: Function,
      default: () => {}
    },
    // eslint-disable-next-line vue/require-default-prop
    view: String,
    shData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // addCcsqdView: false,
      jkrQueryView: false,
      xaingmuQueryView: false,
      queryParams: {
        currentPage: 1,
        pageSize: 100,
        billNumber: undefined,
        startTime: undefined,
        endTime: undefined
      },
      queryJkr: {
        jkr: ''
      },
      jkrDate: [],
      xaingmuDate: [],
      shTable: [],
      startTime: {
        disabledDate: (time) => {
          if (this.queryParams.endTime) {
            return (
              time.getTime() >= new Date(this.queryParams.endTime).getTime()
            )
          }
        }
      },
      endTimes: {
        disabledDate: (time) => {
          if (this.addCcsqdData.starttime || this.addCcsqdData.endtime) {
            const diffTime = Math.abs(new Date(this.addCcsqdData.starttime) - new Date(this.addCcsqdData.endtime))
            this.addCcsqdData.totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1
          }
        }
      }
    }
  },
  created() {
  },
  methods: {
    Nindex(index) {
      const page = this.queryParams.currentPage
      const pageSize = this.queryParams.pageSize
      return index + 1 + (page - 1) * pageSize
    },
    jkrQuery() {
      this.jkrQueryView = true
      this.getJkrList()
    },
    xaingmuQuery() {
      this.xaingmuQueryView = true
      this.getXiangmuList()
    },
    closeAddCcsqdView() {
      this.colseCcsqd()
    },
    handleJkrQuery() {
      var data = {
        cname: this.queryJkr.jkr
      }
      this.$post('/crm/businessTripApplysNew/getCpersonNames', data).then(res => {
        this.jkrDate = res.data
      })
    },
    handleJkrChange(row) {
      this.addCcsqdData.applyPerson = row.cname
      this.addCcsqdData.jkrId = row.code
      this.jkrQueryView = false
    },
    handleXiangmuChange(row) {
      this.addCcsqdData.project = row.xmmc
      this.addCcsqdData.xmdjh = row.djh
      this.jkrQueryView = false
    },
    rqFormatter(val) {
      return this.stringSplitSpace(val)
    },
    stringSplitSpace(val) {
      if (val) {
        return val.split(' ')[0]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
  margin-bottom: 5px !important;
}
.tableClass {
th {
  padding: 0 !important;
  height: 30px;
  line-height: 30px;
}
td {
  padding: 0 !important;
  height: 30px;
  line-height: 30px;
}
}
.tableStyle {
  width: 100%;
  margin-top: 10px;
  text-align: left;
tr {
  height: 40px;
}
}
.td1 {
  width: 9%;
  text-align: center;
}
.td2 {
  width: 50%;
}
.td3 {
  width: 9%;
  text-align: center;
}
.td4 {
  width: 9%;
}
.el-radio {
  margin-right: 10px !important;
}
::v-deep .el-radio__label {
  padding-left: 3px !important;
}
::v-deep .borderHide .el-input__inner {
  height: 30px;
  border-radius: 0;
  border-top: none;
  border-left: none;
  border-right: none;
}
.yjsjStyle {
  margin-left: 5px;
  margin-right: 5px;
}

</style>
